import { BoldifyReplace } from './BoldifyReplace';

function capsFirstLetter(word) {
    
    if (!word)
        return ''; // Handle empty or undefined input

    if(typeof word != String) {
        return word
    }

    return word.charAt(0).toUpperCase() + word.slice(1);
}

const ContentString = ({label, contentString, italics = undefined, hoverTitle = undefined, addPlus=false}) => {
    return contentString ? 
        <p className='skillP' title={hoverTitle}>
            <strong>{label}</strong> 
            <span className='infoDesc'>
                &nbsp;{addPlus && '+'}<BoldifyReplace desc={capsFirstLetter(contentString)} />
            </span>
            {italics && 
                <i className='infoDesc'>
                    {italics}
                </i>
            }
        </p> : null
}

export default ContentString;